import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';

const DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

export default function DayOfWeekCalc() {
  const today = new Date();
  const [d, setD] = useState(today.getDate());
  const [m, setM] = useState(today.getMonth()+1);
  const [y, setY] = useState(today.getFullYear());

  const result = useMemo(() => {
    const dt = new Date(Number(y), Number(m)-1, Number(d));
    if (isNaN(dt.getTime())) return null;
    return { day: DAYS[dt.getDay()], iso: dt.toISOString().slice(0,10),
      dayOfYear: Math.floor((dt - new Date(dt.getFullYear(),0,0)) / 86400000),
      week: Math.ceil((((dt - new Date(dt.getFullYear(),0,1)) / 86400000) + new Date(dt.getFullYear(),0,1).getDay()+1) / 7)
    };
  }, [d, m, y]);

  return (
    <CalcShell look="cnet" title="Day of the Week Calculator" subtitle="Find the day of the week (and day/week of year) for any historical or future date.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="grid grid-cols-3 gap-3">
            <div className="field"><label>Day</label><input type="number" min={1} max={31} value={d} onChange={e => setD(e.target.value)} data-testid="dow-day"/></div>
            <div className="field"><label>Month</label><input type="number" min={1} max={12} value={m} onChange={e => setM(e.target.value)} data-testid="dow-month"/></div>
            <div className="field"><label>Year</label><input type="number" value={y} onChange={e => setY(e.target.value)} data-testid="dow-year"/></div>
          </div>
        </div>
        <div>
          {result && (
            <>
              <div className="p-5 rounded-xl bg-teal-50 border border-teal-200 text-center">
                <div className="text-sm text-slate-600">Day of Week</div>
                <div className="text-4xl font-bold text-teal-700" data-testid="dow-result">{result.day}</div>
                <div className="text-slate-600 mt-1">{result.iso}</div>
              </div>
              <table className="data-table mt-4">
                <tbody>
                  <tr><td>Day of the Year</td><td className="text-right">{result.dayOfYear}</td></tr>
                  <tr><td>Week Number</td><td className="text-right">{result.week}</td></tr>
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </CalcShell>
  );
}
